import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as InvoiceService from 'services/sales/invoice';

export const useInvoiceService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchInvoices = async (options = {}) => {
    const { error, payload } = await InvoiceService.read({ ...options, token });
    if (error) {
      return { invoices: [], size: 0 };
    }

    const {
      data: invoices,
      meta: { size }
    } = payload;
    return { invoices, size };
  };

  const raiseInvoice = async (options = {}) => {
    const { error, payload } = await InvoiceService.generateInvoice({ ...options, token });
    if (error) {
      toast.error(error);
      return null;
    }

    toast.success('Invoice raised successfully.');
    return payload;
  };

  return {
    fetchInvoices,
    raiseInvoice
  };
};
